import { Box, Typography } from "@mui/material";

interface TokenUsageChartProps {
  usage: {
    prompt_tokens?: number;
    completion_tokens?: number;
    total_tokens?: number;
    system_tokens?: number;
    history_tokens?: number;
    rag_tokens?: number;
  } | null;
}

export default function TokenUsageChart({ usage }: TokenUsageChartProps) {
  if (!usage) return null;

  const { prompt_tokens = 0, completion_tokens = 0, total_tokens = 0 } = usage;

  return (
    <Box>
      <Typography variant="caption" sx={{ color: "#A99F8E", fontWeight: 600 }}>
        Token 用量
      </Typography>
      <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="caption" sx={{ color: "#7C6F5C" }}>
            Prompt
          </Typography>
          <Typography variant="caption" sx={{ color: "#A99F8E" }}>
            {prompt_tokens.toLocaleString()}
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: 4, backgroundColor: "#E8E2D9", borderRadius: 2 }}>
          <Box
            sx={{
              width: total_tokens > 0 ? `${(prompt_tokens / total_tokens) * 100}%` : "0%",
              height: "100%",
              backgroundColor: "#5A7D9A",
              borderRadius: 2,
            }}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
          <Typography variant="caption" sx={{ color: "#7C6F5C" }}>
            Completion
          </Typography>
          <Typography variant="caption" sx={{ color: "#A99F8E" }}>
            {completion_tokens.toLocaleString()}
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: 4, backgroundColor: "#E8E2D9", borderRadius: 2 }}>
          <Box
            sx={{
              width: total_tokens > 0 ? `${(completion_tokens / total_tokens) * 100}%` : "0%",
              height: "100%",
              backgroundColor: "#6B8E7B",
              borderRadius: 2,
            }}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
          <Typography variant="caption" sx={{ color: "#7C6F5C", fontWeight: 600 }}>
            Total
          </Typography>
          <Typography variant="caption" sx={{ color: "#7C6F5C", fontWeight: 600 }}>
            {total_tokens.toLocaleString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
